<template>
  <div
    class="logo-box"
    :style="{ background: boxBackground }"
    :class="{ 'sidebar-closed': !isSidebarOpen }"
    @click="$emit('selectLogo')"
  >
    <img :src="logo.content || logo.url" alt="logo" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SidebarLogoPreview",
  props: {
    logo: {
      type: Object,
      required: true,
    },
    isSidebarOpen: {
      type: Boolean,
      default: true,
    },
    overrideBackground: {
      type: String,
    }
  },

  computed: {
    ...mapGetters("project", ["projectColors"]),
    boxBackground() {
      return this.overrideBackground || this.projectColors[0]?.color?.hex || "transparent";
    },
  },
};
</script>

<style lang="scss">
.logo-box {
  display: flex;
  width: 80px;
  height: 80px;
  border-radius: 6px;
  border: 1px solid $grey-light;
  padding: 0.5rem;
  margin: auto 0;

  img {
    display: block;
    margin: auto;
    max-width: 90%;
    max-height: 100%;
  }

  &.sidebar-closed {
    width: 48px;
    height: 48px;
    margin-bottom: 0.8rem;
    padding: 0.2rem;
    img {
      max-width: 100%;
    }
  }
}
</style>